import {
  BackButton,
  StyledText,
  Button,
  DynamicButton,
} from "../../../components/common";
import { NoticeIcon } from "../../../components/svgs";
import { useTheme } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";

const BlackFriday = () => {
  const { themeContext, theme } = useTheme();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();
  const blackFridayDiscountCode = "OMTNPULSE";

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 100,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <div
        style={{
          boxSizing: "border-box",
          padding: "20px",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingInline: 15,
          backgroundColor: "white",
        }}
      >
        <StyledText style={{ marginTop: -1, fontSize: 24 }}>
          Black Friday on Jumia
        </StyledText>
        <BackButton onClick={() => history.goBack()} />

        <StyledText
          style={{
            fontFamily: "MTNRegular",
            fontSize: 12,
            textAlign: "center",
            width: "70%",
          }}
        >
          Enjoy amazing discounts on Jumia this Black Friday when you use your
          Pulse discount code
        </StyledText>
        <HorizontalSeparator />
        <DiscountCardContainer bgColor={background}>
          <StyledText
            style={{
              fontFamily: "MTNRegular",
              fontSize: 18,
              color: "#fff",
            }}
          >
            Your discount code is
          </StyledText>
          <StyledText
            style={{
              fontFamily: "MTNBold",
              fontSize: 24,
              margin: 0,
              color: "#fff",
            }}
          >
            {blackFridayDiscountCode}
          </StyledText>
        </DiscountCardContainer>
        <ExpireNoticeContainer>
          <NoticeIcon width={15} fill="black" style={{ marginRight: 5 }} />
          <StyledText
            style={{
              fontFamily: "MTNRegular",
              fontSize: 12,
              margin: 0,
            }}
          >
            Use code at checkout for 20% off items
          </StyledText>
        </ExpireNoticeContainer>

        <HorizontalSeparator />

        <OutlinedContainer color={background}>
          <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
            Guidelines
          </StyledText>

          {guidelines.map((note, index) => {
            return (
              <TipsContainer key={index}>
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                >
                  {note}
                </StyledText>
              </TipsContainer>
            );
          })}
        </OutlinedContainer>
        <OutlinedContainer color={background}>
          <StyledText style={{ fontFamily: "MTNMedium", fontSize: 18 }}>
            Tips
          </StyledText>

          {tips.map((note, index) => {
            return (
              <TipsContainer key={index}>
                <CircleContainer>
                  <Dot color={background} />
                </CircleContainer>
                <StyledText
                  style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                >
                  {note}
                </StyledText>
              </TipsContainer>
            );
          })}
        </OutlinedContainer>
        <div style={{ paddingBottom: "30px", textAlign: "center" }}>

          <Button
            style={{
              backgroundColor: background,
              width: "80%",
              alignSelf: "center",
              margin: "20px auto",
              marginTop: 20,
            }}
            onClick={() => {
              window.open("https://cutt.ly/DwTrp4GC", "Jumia");
            }}
          >
            <StyledText color="white">Shop now</StyledText>
          </Button>
          <a style={{ fontFamily: "MTNRegular", }} href="https://www.jumia.com.gh/sp-terms-and-conditions/">Terms &amp; Conditions</a>
        </div>
      </div>
    </div>
  );
};

export default BlackFriday;

const OutlinedContainer = styled.div`
  width: "90%";
  border-width: 2;
  border: 1.5px solid ${({ color }) => color};
  border-radius: 15px;
  padding-inline: 10px;
  margin-top: 20px;
`;

const TipsContainer = styled.div`
  display: flex;
`;
const HorizontalSeparator = styled.div`
  width: 80%;
  height: 10px;
  background-color: #7f7f7f;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;
const ExpireNoticeContainer = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  margin-top: 20px;
`;
const DiscountCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ bgColor }) => bgColor};
width:80%
  align-self: center;
  border-radius:10px;
  padding-bottom:20px
`;

const guidelines = [
  "Browse Jumia for the coolest stuff. Load up your shopping cart like a pro.",
  "At checkout, select 'MTN Mobile Money' as your payment method.",
  "Now, here’s the secret sauce: Copy the discount code provided. Its your golden ticket to extra savings!",
  "Paste the code where it says “Promo Code” on the Jumia platform and click “Apply.” That’s it!",
  "Watch as your total drops by an extra 20%",
  "The code is valid only for the Black Friday period.",
];
const tips = [
  "The discount code is only valid when you pay with MTN Mobile Money, so make sure to choose it.",
  "Remember, Jumia’s already offering discounts up to 50%, and you get an extra 20% from MTN Pulse. It’s a shopping bonanza!",
];
